"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function CouponOff(props) {
    var className = props.className, style = props.style;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var defaultUnit = '$';
    var defaultOff = 'OFF';
    var defaultStatus = 'normal';
    /** 中间凹陷的部分 */
    function renderSnap() {
        return (react_1.default.createElement("div", { className: "coupon-snap" },
            react_1.default.createElement("span", { className: "snap-left" }),
            react_1.default.createElement("span", { className: "snap-right" })));
    }
    /**
     * 左侧数字部分
     */
    function renderLeft() {
        var unit = props.unit, txt = props.txt, off = props.off, backgroundImage = props.backgroundImage;
        return (react_1.default.createElement("div", { className: "coupon-off-left" },
            react_1.default.createElement("div", { className: "left-item" },
                react_1.default.createElement("div", { className: "left-unit" }, unit || defaultUnit),
                react_1.default.createElement("div", { className: "left-txt" },
                    txt,
                    react_1.default.createElement("div", { className: "left-txt-inline" }, txt))),
            react_1.default.createElement("div", { className: "left-off" }, off || defaultOff),
            react_1.default.createElement("div", { className: "left-img", style: { backgroundImage: backgroundImage } })));
    }
    /**
     * 右侧文字描述部分
     */
    function renderRight() {
        var title = props.title, describe = props.describe, buttonNormalText = props.buttonNormalText, buttonDisableText = props.buttonDisableText, status = props.status, onClick = props.onClick;
        var btnStatus = status || defaultStatus;
        return (react_1.default.createElement("div", { className: "coupon-off-right" },
            react_1.default.createElement("div", { className: "off-right-top" }, title),
            react_1.default.createElement("div", { className: "off-right-center" }, describe),
            react_1.default.createElement("div", { className: "off-right-bottom" },
                react_1.default.createElement("button", { className: (0, classnames_1.default)('coupon-off-button', "status-".concat(btnStatus)), onClick: onClick }, btnStatus === defaultStatus ? buttonNormalText : buttonDisableText))));
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)(className, "".concat(classPrefix, "-coupon-off")) },
        renderLeft(),
        renderSnap(),
        renderRight()));
}
exports.default = CouponOff;
//# sourceMappingURL=CouponOff.js.map